<template>
  <div>
    <vs-prompt
      title="Add venue Engage Messenger"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Venue</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select
                autocomplete
                label="Search for venue..."
                v-model="newVenueSelect"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.name"
                  v-for="(item, index) in userVenues"
                />
              </vs-select>
            </div>
          </div>
          <div class="vx-row mb-6" v-if="newVenueSelect">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Business page ID</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Page ID"
                v-model="fbPageId"
              />
            </div>
          </div>
          <div class="vx-row mb-6" v-if="newVenueSelect">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Business page token</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Page token"
                v-model="fbPageToken"
              />
              <p class="mt-4">
                These fields can be found in the Messenger menu of the
                <i>REKOM Engage</i> app on Facebook.
              </p>
              <a
                href="https://developers.facebook.com/apps/4965961080190445/dashboard/?business_id=1732530493686066"
                target="_blank"
                >Go to Facebook app</a
              >
            </div>
          </div>
          <!--<div class="vx-row mb-6" v-if="newVenueSelect">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Business page app secret</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="App secret"
                v-model="fbAppSecret"
              />
            </div>
          </div>-->
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      newVenueSelect: null,
      fbPageId: "",
      fbPageToken: "",
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userVenues: "venues/venues",
    }),
    validForm() {
      return (
        this.newVenueSelect !== null &&
        this.fbPageToken != "" &&
        this.fbPageId != ""
      );
    },
  },
  methods: {
    show() {
      this.newVenueSelect = null;
      this.prompt = true;
    },
    async accept() {
      const dto = {
        venueId: this.newVenueSelect.venueId,
        venueName: this.newVenueSelect.name,
        pageToken: this.fbPageToken,
        //appSecret: this.fbAppSecret,
        pageId: this.fbPageId,
      };

      this.$vs.loading();

      await this.$store.dispatch("chat/createPageVenueIdentity", dto);

      this.$vs.notify({
        color: "success",
        title: `Venue added`,
        text: "Venue added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
